import { render, staticRenderFns } from "./CourseFilePage.vue?vue&type=template&id=1318dd6b&"
import script from "./CourseFilePage.vue?vue&type=script&lang=ts&"
export * from "./CourseFilePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports